import { Link, createFileRoute } from '@tanstack/react-router';
import { NOTIFICATION_TYPES } from '@regent/shared';
import { Button } from '@/components/ui';
import { AuthLayout } from '@/features/auth/auth-layout';

export const Route = createFileRoute('/unsubscribed')({
  validateSearch: (search: Record<string, unknown>): { status?: string; type?: string } => ({
    ...(typeof search.status === 'string' ? { status: search.status } : {}),
    ...(typeof search.type === 'string' ? { type: search.type } : {}),
  }),
  component: UnsubscribedPage,
});

/** Landing page for the unsubscribe link in notification emails. Works without signing in. */
function UnsubscribedPage() {
  const { status, type } = Route.useSearch();
  const ok = status === 'ok';
  const label = NOTIFICATION_TYPES.find((t) => t.type === type)?.label.toLowerCase();
  return (
    <AuthLayout title={ok ? 'You are unsubscribed' : 'This link did not work'}>
      <p className="text-center text-sm text-fg-muted" role={ok ? 'status' : 'alert'}>
        {ok
          ? label
            ? `You will no longer get emails about ${label}. They still show up in your Regent inbox.`
            : 'You will no longer get notification emails. Notifications still show up in your Regent inbox.'
          : 'The unsubscribe link is invalid or incomplete. You can change email settings from your notification settings in Regent.'}
      </p>
      <Button asChild variant="primary" className="mt-5 w-full">
        <Link to="/">Open Regent</Link>
      </Button>
    </AuthLayout>
  );
}
